import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import ServiceSidebar from '../ServiceSidebar/Main'
import itc from "../../../assets/images/services/webapp.png";
import { useTranslation } from 'react-i18next';

const Webapp = () => {
	// const [clicked, setClicked] = useState(0);
	// const faqs = [
	// 	{
	// 		question: "Nulla eu nisi pellentesque, ultrices lorem eget, mattis dolo",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Praesent nec ante sed libero tempus rutrum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Integer et mi in eros commodo bibendum",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	},
	// 	{
	// 		question: "Proin commodo turpis eu leo tempus varius",
	// 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
	// 	}
	// ]
  const { t } = useTranslation();
	return (
    <>
      <Breadcumb Title={t('breadcrumb.web_application')} Breadcumb={t('breadcrumb.services')} />
      <section className="section-padding--bottom section-padding--top service-details--page">
        <div className="container">
          <div className="row ">
            <div className="col-lg-8">
              <div className="service-details__image">
                <img src={itc} alt="" />
              </div>
              <h3 className="service-details__title">Web Application</h3>
              <div className="service-details__content">
                <p>
                  {t('breadcrumb.web_developemnt_p1')}
                </p>
                <p>{t('breadcrumb.web_developemnt_p2')} </p>
                <p>{t('breadcrumb.web_developemnt_p3')}</p> 
               
                <h4>
                {t('breadcrumb.web_developemnt_h4')}
                </h4>
                <p>
                - {t('breadcrumb.web_developemnt_h4_sub1')}
                </p>
                <p>
                - {t('breadcrumb.web_developemnt_h4_sub2')}
                </p>
                <p>
                - {t('breadcrumb.web_developemnt_h4_sub3')}
                </p>
                <p>- {t('breadcrumb.web_developemnt_h4_sub4')}</p>
                <p>
                - {t('breadcrumb.web_developemnt_h4_sub5')}
                </p>
                <p>
                - {t('breadcrumb.web_developemnt_h4_sub6')}
                </p>
              </div>
              <h3 className="service-details__title"> {t('breadcrumb.web_developemnt_h4_services')}</h3>
              <div className="service-details__content">
                
                <h4>
                 {t('breadcrumb.web_developemnt_services_php')}
                </h4>
                <p>
                 {t('breadcrumb.web_developemnt_services_php_description')}
                </p>

                <h4>
                  {t('breadcrumb.web_developemnt_services_php_description1')}
                </h4>
                <p>
                 {t('breadcrumb.web_developemnt_services_php_description2')}
                </p>
                <p>
                <b>{t('breadcrumb.web_developemnt_services_php_item1_title')}</b>
                </p>
                <p>{t('breadcrumb.web_developemnt_services_php_item1_description')}</p>

                <p><b>{t('breadcrumb.web_developemnt_services_php_item2_title')}</b></p>

                
                <p>{t('breadcrumb.web_developemnt_services_php_item2_description')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_php_item3_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_php_item3_description')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_php_item4_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_php_item4_description')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_php_item5_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_php_item5_description')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_opensource_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_opensource_p1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_opensource_p2')}</p>
                <p>{t('breadcrumb.web_developemnt_services_opensource_p3')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_ror_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_ror_p1')}</p>
                <p><b>{t('breadcrumb.web_developemnt_services_ror_subtitle')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_ror_p2')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_html5_title')}</h4>
                <p><b>{t('breadcrumb.web_developemnt_services_html5_subtitle')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_html5_p1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_html5_p2')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_html5_item1_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_html5_item1_description')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_html5_item2_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_html5_item2_description')}</p>
                
                <p><b>{t('breadcrumb.web_developemnt_services_html5_item3_title')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_html5_item3_description')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_ajax_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_ajax_p1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_ajax_p2')}</p>
                <p>{t('breadcrumb.web_developemnt_services_ajax_p3')}</p>
                <p>{t('breadcrumb.web_developemnt_services_ajax_p4')}</p>
                <p>{t('breadcrumb.web_developemnt_services_ajax_p5')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_uiux_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_uiux_p1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_uiux_item1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_uiux_item2')}</p>
                <p>{t('breadcrumb.web_developemnt_services_uiux_item3')}</p>
                <p>{t('breadcrumb.web_developemnt_services_uiux_item4')}</p>
                <p>{t('breadcrumb.web_developemnt_services_uiux_item5')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_nodejs_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_nodejs_p1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_nodejs_item1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_nodejs_item2')}</p>
                <p>{t('breadcrumb.web_developemnt_services_nodejs_item3')}</p>
                <p>{t('breadcrumb.web_developemnt_services_nodejs_item4')}</p>
                
                <h4>{t('breadcrumb.web_developemnt_services_expressjs_title')}</h4>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_p1')}</p>
                <p><b>{t('breadcrumb.web_developemnt_services_expressjs_subtitle')}</b></p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item1')}</p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item2')}</p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item3')}</p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item4')}</p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item5')}</p>
                <p>{t('breadcrumb.web_developemnt_services_expressjs_item6')}</p>
              </div>

              <h3 className="service-details__title">{t('breadcrumb.web_developemnt_why_select_us_title')}</h3>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item1')}</p>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item2')}</p>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item3')}</p>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item4')}</p>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item5')}</p>
              <p>{t('breadcrumb.web_developemnt_why_select_us_item6')}</p>



              <div className="row gutter-y-30 service-details__box-wrapper">
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-consulting"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('breadcrumb.web_developemnt_it_consultant_title')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('breadcrumb.web_developemnt_it_consultant_description')}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__box">
                    <i className="service-details__box__icon icon-chip"></i>
                    <div className="service-details__box__content">
                      <h3 className="service-details__box__title">
                        <Link to="#">{t('breadcrumb.web_developemnt_it_specialist_title')}</Link>
                      </h3>
                      <p className="service-details__box__text">
                        {t('breadcrumb.web_developemnt_it_specialist_description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row gutter-y-30">
                <div className="col-md-6 col-sm-12">
                  <img
                    src="assets/images/services/service-d-2.jpg"
                    className="service-details__sub-image"
                    alt=""
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__caption">
                    <h3 className="service-details__caption__title">
                      Our Benefits
                    </h3>
                    <p className="service-details__caption__text">
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum.
                    </p>
                    <ul className="service-details__caption__list">
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Praesent efficitur quam sit amet
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Nunc cursus dolor id purus euismod
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Quisque tincidunt eros ac place viverra
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}

              {/* <div className="row">
                <div className="col-md-12">
                  <div
                    className="accrodion-grp service-details__accrodion"
                    data-grp-name="service-details__accrodion-1"
                  >
                    {faqs.map((item, index) => (
                      <div
                        className={`accrodion wow fadeInUp ${
                          index === clicked && "active"
                        }`}
                        key={index}
                        data-wow-delay="0ms"
                      >
                        <div className="accrodion-title">
                          <h4 onClick={() => setClicked(index)}>
                            {item.question}
                            <span className="accrodion-icon"></span>
                          </h4>
                        </div>
                        {index === clicked && (
                          <div className="accrodion-content">
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-lg-4 sidebar-column">
              <ServiceSidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Webapp